import { ref } from 'vue';

const getTeams = () => {
    const teams_error = ref(null);
    const teams = ref(null);

    const loadTeams = async () => {
      try {
        let data = await fetch("/api/teams");

        if (!data.ok) {
          throw Error("Can't load data");
        }

        teams.value = await data.json();

        // console.log('teams', teams.value);
      } catch (err) {
        teams_error.value = err.message;
      }
    };

    return { teams, teams_error, loadTeams};
}

export default getTeams;
